module.exports = __webpack_public_path__ + "img/logo_1x.4c0ee4cc.png";